<template>
    <div v-if="failure" class="failure" :class="{ 'failure--final': isFinal }">
        <p class="failure__message" dir="auto">{{ message }}</p>

        <!-- As the backend worded them: the `audio` message is written to be
             put in front of a manager unchanged. -->
        <ul v-if="fieldMessages.length" class="failure__fields">
            <li v-for="(text, index) in fieldMessages" :key="index" dir="auto">
                {{ text }}
            </li>
        </ul>

        <!-- Only where trying again can change the answer. -->
        <v-btn
            v-if="canRetry"
            small
            text
            color="#967adc"
            :disabled="isSending"
            @click="retry"
        >
            {{ $t('pages.assistant.errors.retry') }}
        </v-btn>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
    assistantActionTypes,
    assistantGetterTypes,
} from '@/store/modules/assistant/types'
import { ASSISTANT_FAILURES } from '@/consts/assistant'

export default {
    name: 'AssistantFailure',
    computed: {
        ...mapGetters('assistant', {
            failure: assistantGetterTypes.GET_FAILURE,
            canRetry: assistantGetterTypes.GET_CAN_RETRY,
            isSending: assistantGetterTypes.GET_IS_SENDING,
        }),
        message: function () {
            if (!this.failure) return ''

            // A 422 carries its own wording; everything else is named here.
            if (
                this.failure.type === ASSISTANT_FAILURES.VALIDATION &&
                this.failure.message
            ) {
                return this.failure.message
            }

            return this.$t(`pages.assistant.errors.${this.failure.type}`)
        },
        fieldMessages: function () {
            const fields = this.failure?.fields || {}

            return Object.keys(fields).reduce(
                (all, field) => all.concat(fields[field]),
                []
            )
        },
        // Nothing the manager can do from here.
        isFinal: function () {
            return (
                this.failure?.type === ASSISTANT_FAILURES.SWITCHED_OFF ||
                this.failure?.type === ASSISTANT_FAILURES.FORBIDDEN
            )
        },
    },
    methods: {
        ...mapActions('assistant', {
            retry: assistantActionTypes.RETRY,
        }),
    },
}
</script>

<style scoped lang="scss">
.failure {
    padding: 10px 16px;
    border-top: 1px solid #eceeef;
    background: #fdf3f4;
    color: #a4373f;

    &--final {
        background: #f3f4f5;
        color: #55595c;
    }

    &__message {
        margin: 0;
        font-size: 13px;
        unicode-bidi: plaintext;
    }

    &__fields {
        margin: 4px 0 0;
        padding-left: 18px;
        font-size: 12px;

        @include for-hebrew {
            padding-left: 0;
            padding-right: 18px;
        }
    }
}
</style>
